import { render, staticRenderFns } from "./BriqButton.vue?vue&type=template&id=bcfc3332&scoped=true&lang=pug&"
import script from "./BriqButton.vue?vue&type=script&lang=js&"
export * from "./BriqButton.vue?vue&type=script&lang=js&"
import style0 from "./BriqButton.vue?vue&type=style&index=0&id=bcfc3332&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfc3332",
  null
  
)

export default component.exports